<template>
  <div class="info-panel info-panel--solo">
    <p>
      {{ $t('search.empty.no_products_found') }}
    </p>
    <ul>
      <li>{{ $t('search.empty.digitation_errors') }}</li>
      <li>{{ $t('search.empty.less_words') }}</li>
      <li>
        {{ $t('search.empty.less_specific') }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SearchWithoutResult',
}
</script>
